import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !key) {
  throw new Error(`Supabase env vars mancanti. URL: ${url}, KEY: ${key ? 'ok' : 'undefined'}`);
}

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'gp_auth',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
});
